import { ArrowDownRight, MessageCircle, Phone, Star } from "lucide-react";
import { useEffect, useRef } from "react";

export default function Hero({ phoneTel, whatsappUrl }) {
  const heroRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      if (!heroRef.current) return;
      const amount = Math.min(window.scrollY * 0.045, 22);
      heroRef.current.style.setProperty("--parallax", `${amount}px`);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="hero" id="top" ref={heroRef} aria-labelledby="hero-heading">
      <div className="hero-copy">
        <div className="hero-overline">Fine dine in Varanasi</div>
        <h1 className="hero-title" id="hero-heading" data-testid="hero-heading">
          <span className="hero-line">A table for</span>
          <span className="hero-line">every kind of</span>
          <span className="hero-line">gathering.</span>
        </h1>
        <p className="hero-intro">
          Hashtag is a multi-cuisine restaurant and garden where the evening can move from a quiet table to a 250-guest celebration without missing a beat.
        </p>
        <div className="hero-actions">
          <a href={phoneTel} className="button button-primary" data-testid="hero-primary-call-cta">
            <Phone aria-hidden="true" />
            Call for a table
          </a>
          <a href={`${whatsappUrl}?text=${encodeURIComponent("Hello Hashtag Restaurant, I would like to plan a celebration in your garden.")}`} className="button button-ghost" target="_blank" rel="noreferrer" data-testid="hero-secondary-whatsapp-cta">
            <MessageCircle aria-hidden="true" />
            WhatsApp celebrations
          </a>
        </div>
        <div className="hero-meta-row">
          <div className="hero-meta" data-testid="hero-rating-info">
            <strong><Star size={15} fill="currentColor" aria-hidden="true" /> 4.0 / 5</strong>
            <span>1,076 Google reviews</span>
          </div>
          <div className="hero-meta" data-testid="hero-hours-info">
            <strong>Open until 11 pm</strong>
            <span>Today · Come as you are</span>
          </div>
        </div>
      </div>
      <div className="hero-media-wrap">
        <div className="hero-media-frame">
          <img className="hero-media-image" src="/assets/main-exterior.png" alt="Hashtag restaurant exterior glowing at night" />
        </div>
        <div className="hero-coordinates" aria-hidden="true">25.3176° N · 82.9739° E</div>
        <a href="#menu" className="hero-scroll-cue" data-testid="hero-menu-link">
          <span>Read the table</span>
          <ArrowDownRight aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}
